import { CustomAlarmsFormContentContainer } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form-content.container';
import { CustomAlarmsFormProvider } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/providers/custom-alarms-form.provider';

export const SettingsDevicesCustomAlarmFormContainer: React.FC = () => (
    <CustomAlarmsFormProvider>
        <CustomAlarmsFormContentContainer />
    </CustomAlarmsFormProvider>
);
